;(function ($) {
    $.fn.naturataNavigationToggle = function () {
        return $(this).each(function () {
            var container = $(this);
            var body = $('body');
            var action = container.data('naturataNavigationToggle');
            container.on('click', function (e) {
                e.preventDefault();
                body.toggleClass('navigation-panel-visible', action == "open").removeClass('searchbar-visible');
            });
        });
    };
    $(function(){
        $('header.header').append($('<div/>').addClass('navigation-panel-shadow').attr({'data-naturata-navigation-toggle': 'close'}));
        $('[data-naturata-navigation-toggle]').naturataNavigationToggle();
        if ($(window).width() >= 1440) {
            $('body').addClass('navigation-panel-visible');
        }

        $('header.header').on('click', function(e) {
            e.stopPropagation();
        });

        $('body').on('click', function() {
            $(this).removeClass('submenu-open');
            $('header.header').find('li.has-submenu').removeClass('open');
        });
    });
})(jQuery);
